import { ProductTypeListProps } from "@ultracommerce/react-storefront/global/src/modules/Product/Components/ProductTypeList/ProductTypeList.componentModel";
import { useComponentData } from "@ultracommerce/react-storefront/global/src/modules/Product/Components/ProductTypeList/ProductTypeList.componentService";
import { ProductTypeListView } from "./ProductTypeList.componentView";

const CustomProductTypeList = (props: ProductTypeListProps) => {
  const { componentData } = useComponentData(props);
  return <ProductTypeListView componentData={componentData} />;
};
export { CustomProductTypeList, type ProductTypeListProps };
